<div class="modal-container">
  <div class="modal-header">
    <div>{{ 'aircraft.registration.modal.title' | translate }}</div>
    <div class="modal-header-close-btn icon-close" (click)="cancel()"></div>
  </div>
  <div class="seperator">
    <hr />
  </div>
  <div class="modal-body">
    <span>
      <p>
        {{
          'aircraft.registration.modal.assignToCompany'
            | translate: { count: data.validCount, company: data.companyName }
        }}
      </p>
      <p>
        {{
          'aircraft.registration.modal.invalidDiscard'
            | translate: { count: data.invalidCount }
        }}
      </p>
      <p>{{ 'aircraft.registration.modal.confirmQuestion' | translate }}</p>
    </span>
  </div>
</div>

<mat-dialog-actions class="action-box">
  <a (click)="cancel()" class="cancel">
    {{ 'aircraft.registration.modal.cancel' | translate }}
  </a>
  <app-button
    (click)="confirm()"
    [small]="true"
    [title]="'aircraft.registration.modal.proceed' | translate"
    class="flex-position-end"
  >
  </app-button>
</mat-dialog-actions>
